import api from './api';

const BASE = '/hr/mobile-notifications';

const unwrap = (response) => response?.data;

const firstError = (errors) => {
  const out = {};
  Object.entries(errors || {}).forEach(([field, messages]) => {
    out[field] = Array.isArray(messages) ? String(messages[0] || '') : String(messages || '');
  });
  return out;
};

export const mapLaravelError = (error) => {
  const payload = error?.response?.data || {};

  if (payload?.errors && typeof payload.errors === 'object') {
    return {
      message: payload.message || 'Validation failed.',
      fieldErrors: firstError(payload.errors),
      status: error?.response?.status || 422,
    };
  }

  return {
    message: payload?.message || error?.message || 'Request failed.',
    fieldErrors: {},
    status: error?.response?.status || 500,
  };
};

export const listMobileNotificationCampaigns = async (params = {}) => unwrap(await api.get(BASE, { params }));
export const createMobileNotificationCampaign = async (payload) => unwrap(await api.post(BASE, payload));
export const getMobileNotificationCampaign = async (id) => unwrap(await api.get(`${BASE}/${id}`));
export const updateMobileNotificationCampaign = async (id, payload) => unwrap(await api.put(`${BASE}/${id}`, payload));
export const estimateMobileNotificationRecipients = async (id, payload = {}) =>
  unwrap(await api.post(`${BASE}/${id}/estimate`, payload));
export const getMobileNotificationLookups = async () => unwrap(await api.get(`${BASE}/lookups`));
export const searchMobileNotificationEmployees = async (params = {}) =>
  unwrap(await api.get(`${BASE}/employees/search`, { params }));
export const scheduleMobileNotificationCampaign = async (id, payload) =>
  unwrap(await api.post(`${BASE}/${id}/schedule`, payload));
export const cancelMobileNotificationCampaign = async (id) =>
  unwrap(await api.post(`${BASE}/${id}/cancel`));
export const duplicateMobileNotificationCampaign = async (id) =>
  unwrap(await api.post(`${BASE}/${id}/duplicate`));
export const deleteMobileNotificationCampaign = async (id) =>
  unwrap(await api.delete(`${BASE}/${id}`));
export const listMobileNotificationDeliveries = async (id, params = {}) =>
  unwrap(await api.get(`${BASE}/${id}/deliveries`, { params }));

const mobileNotificationCampaignsApi = {
  listMobileNotificationCampaigns,
  createMobileNotificationCampaign,
  getMobileNotificationCampaign,
  updateMobileNotificationCampaign,
  estimateMobileNotificationRecipients,
  getMobileNotificationLookups,
  searchMobileNotificationEmployees,
  scheduleMobileNotificationCampaign,
  cancelMobileNotificationCampaign,
  duplicateMobileNotificationCampaign,
  deleteMobileNotificationCampaign,
  listMobileNotificationDeliveries,
  mapLaravelError,
};

export default mobileNotificationCampaignsApi;
